import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Repo from "./Utility/Repo";
import useLocalStorage from "./Utility/useLocalStorage";
function LoginForm() {
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");
  const [passwordError, setpasswordError] = useState("");
  const [emailError, setemailError] = useState("");
  const [errPassword, setErrPassword] = useState(false);

  const [localStorage, setLocalStorage] = useLocalStorage("LoginUser");

  const handleValidation = (event) => {
    let formIsValid = true;

    if (
      !email.match(/^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/)
    ) {
      formIsValid = false;
      setemailError("Email non Valida!");
      return false;
    } else {
      setemailError("");
      formIsValid = true;
    }

    // if (!password.match(/^[a-zA-Z]{8,22}$/)) {
    //   formIsValid = false;
    //   setpasswordError(
    //     "La lunghezza deve essere di almeno 8 caratteri e al massimo di 22."
    //   );
    //   return false;
    // } else {
    //   setpasswordError("");
    //   formIsValid = true;
    // }

    return formIsValid;
  };

  const loginSubmit = (e) => {
    e.preventDefault();

    var data = {
      email: email,
      password: password,
    };

    if (handleValidation()) {
      Repo.loginUser(data)
        .then((response) => {
          if (response.data) {
            setLocalStorage(response.data);
            window.location.href = "/";
          } else {
            setErrPassword(true);
          }
        })
        .catch(function (error) {
          setErrPassword(true);
        });
    }
  };

  return (
    <>
      <div className="row">
        <h2 className="mt-5 text-center">Effettua il Login</h2>
      </div>
      <div className="container mt-3 mb-5">
        <div className="row d-flex justify-content-center">
          <div className="col-md-4">
            <form
              id="loginform"
              onSubmit={loginSubmit}
              style={{
                padding: "25px",
                border: "1px solid black",
                borderRadius: "5px",
              }}
            >
              <div className="form-group mt-2">
                <label>Email:</label>
                <input
                  type="email"
                  className="form-control"
                  id="EmailInput"
                  name="EmailInput"
                  aria-describedby="emailHelp"
                  placeholder="Email"
                  onChange={(event) => setEmail(event.target.value)}
                />
                <small id="emailHelp" className="text-danger form-text">
                  {emailError}
                </small>
              </div>
              <div className="form-group mt-2">
                <label>Password:</label>
                <input
                  type="password"
                  className="form-control"
                  id="exampleInputPassword1"
                  placeholder="Password"
                  onChange={(event) => setPassword(event.target.value)}
                />
                <small id="passworderror" className="text-danger form-text">
                  {passwordError}
                </small>
              </div>
              <p className="mt-2">
                Se non sei ancora iscritto,{" "}
                <a href="/register">registrati qui.</a>
              </p>
              {errPassword && (
                <>
                  <h5 className="text-danger">Password o Email Errata!</h5>
                </>
              )}
              <button
                type="submit"
                className="btn btn-primary mt-3"
                style={{ marginLeft: "37%", width: "auto" }}
              >
                Conferma
              </button>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
export default LoginForm;
